import(/* webpackMode: "eager" */ "/src/node_modules/.pnpm/next@15.5.15_@babel+core@7.26.10_@opentelemetry+api@1.9.1_@playwright+test@1.52.0_babel_34916a44671fab46835adeca27b6f92e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-detail/[shop_sku]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/GlobalDialog/Loading/LoadingFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/ImageResourceHint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
